<footer class="footer">
  <div class="footer__inner container">

    <div class="footer__brand">
      <a routerLink="/" class="footer__logo" aria-label="Medicvoy home">
        <img src="assets/images/logo-white.svg" alt="Medicvoy" class="footer__logo-img" width="107" height="40">
        <span class="footer__logo-sep" aria-hidden="true"> | </span>
        <span class="footer__logo-sub">DENTAL</span>
      </a>
      <p class="footer__tagline">Premium Dental Care, Made Affordable.</p>
      <p class="footer__email">
        <span class="footer__email-label">Email us:</span>
        <app-copy-email [email]="contactEmail" tone="inverse" />
      </p>
    </div>

    <nav class="footer__nav" aria-label="Footer navigation">
      <ul>
        @for (link of navLinks; track link.path) {
          <li><a [routerLink]="link.path" class="footer__link">{{ link.label }}</a></li>
        }
      </ul>
    </nav>

    <nav class="footer__legal" aria-label="Legal links">
      <ul>
        @for (link of legalLinks; track link.path) {
          <li><a [routerLink]="link.path" class="footer__link">{{ link.label }}</a></li>
        }
        <li><a href="#" class="footer__link" (click)="openCookieSettings($event)">Cookie Settings</a></li>
      </ul>
    </nav>

  </div>

  <div class="footer__bottom container">
    <p>&copy; {{ currentYear }} Medicvoy. All rights reserved.</p>
  </div>
</footer>
